module.exports = __webpack_public_path__ + "img/1514661754.8c14d595.jpg";